export const tablesAndTicketsTableStyle = {
	wrapper: {
		position: 'relative',
		width: '100%',
		height: '100%',
		overflow: 'inherit',
		borderRadius: '8px',
		background: 'var(--default-white)',
		boxShadow: 'var(--box-shadow--1)',
		padding: '12px 0',
	},

	searchButton: {
		textTransform: 'inherit',
		width: '200px',

		'@media (max-width: 767.98px)': {
			display: 'none',
		},

		'& svg': {
			width: '24px',
			height: '24px',

			'& path': {
				fill: 'var(--default-white)',
			},
		},
	},

	tableContent: {
		display: 'flex',
		flexDirection: 'column',
		justifyContent: 'space-between',
		height: 'calc(100% - 46px)',
	},

	container: {
		padding: '0 16px',
	},

	table: {
		maxWidth: '1087px',
		tableLayout: 'fixed',
	},

	tableHeader: {
		'& > :nth-of-type(1)': {
			width: '12%',
		},
		'& > :nth-of-type(2)': {
			width: '12%',
		},
		'& > :nth-of-type(3)': {
			width: '22%',
		},
		'& > :nth-of-type(4)': {
			width: '14%',
		},
		'& > :nth-of-type(5)': {
			width: '11%',
		},
		'& > :nth-of-type(6)': {
			width: '11%',
		},
		'& > :nth-of-type(7)': {
			width: '10%',

			'@media (max-width: 1023.98px)': {
				borderTopRightRadius: '8px',
				borderBottomRightRadius: '8px',
				width: '11%',
			},
			'@media (max-width: 800px)': {
				borderTopRightRadius: '8px',
				borderBottomRightRadius: '8px',
				width: '13%',
			},
			'& svg': {
				marginLeft: '1px',
			},
		},
		'& > :nth-of-type(8)': {
			width: '5%',

			'@media (max-width: 1023.98px)': {
				display: 'none',
			},
		},
	},

	tableBody: {
		'& > :nth-of-type(1)': {
			fontWeight: '700',
		},
		'& > :nth-of-type(2)': {
			fontWeight: '700',
		},

		'& > :nth-of-type(3) .MuiBox-root': {
			'& > .MuiTypography-root:nth-of-type(1)': {
				fontWeight: 700,
			},
			'& > .MuiTypography-root:nth-of-type(2)': {
				fontSize: '12px',
				color: 'var(--neutral-300)',
			},
		},
		'& > :nth-of-type(4)': {
			fontSize: '16px',
		},

		'& > :nth-of-type(8)': {
			'@media (max-width: 1023.98px)': {
				display: 'none',
			},
		},

		'& .MuiTableCell-root': {
			textOverflow: 'ellipsis',
			overflow: 'hidden',
			height: '42px',
			paddingTop: '8px !important',
			paddingBottom: '8px !important',
		},
	},

	headerCell: {
		display: 'flex',
	},

	headerCellTitle: {
		maxWidth: '57px',
		display: 'block',
		textAlign: 'right',
		color: 'var(--neutral-500)',
	},

	bodyCell: {
		display: 'flex',
		gap: '12px',
	},

	bodyCellImage: {
		marginLeft: '-8px',
	},

	bodyCellImageContent: {
		display: 'flex',
		flexDirection: 'column',
		justifyContent: 'center',
	},

	bodyCellImageContentName: {
		fontSize: '16px !important',
		fontWeight: '700 !important',
	},

	bodyCellImageContentCategory: {
		color: 'var(--neutral-300) !important',
	},

	menuItem: {
		width: '100%',
		padding: '8px 16px',
		cursor: 'pointer',

		'&:hover': {
			backgroundColor: 'var(--background-grey-op-50-1)',
		},
	},

	disabledMenuItem: {
		color: 'var(--neutral-300)',
		cursor: 'default',
},

	modal: {
		'.MuiPaper-root': {
			position: 'relative',
			maxWidth: '1170px',
			width: '100%',
			maxHeight: 'calc(100% - 48px)',
			height: '100%',
			padding: '48px 38px 0 48px',
			scrollbarGutter: 'stable',
			margin: '0 15px',
			borderRadius: '8px 8px 0 0 ',
		},

		'&.MuiDialog-root': {
			height: 'calc(100% - 80px)',
		},
	},

	loader: {
		position: 'absolute',
		left: 'calc(50% - 25px)',
		top: '200px',
	},

	pagination: {
		display: 'flex',
		justifyContent: 'flex-end',
		marginRight: '16px',
		marginBottom: '12px',

		'@media (max-width: 1199.98px)': {
			display: 'none',
		},
	},

	modalNotify: {

		'.MuiPaper-root': {
			width: '100%',
			maxWidth: '820px',
			padding: '48px 24px 48px',
		},

		'.MuiDialog-container': {},
	},
};
